import { Capacitor, registerPlugin } from '@capacitor/core';
import { feedbackSettings } from './feedbackSettings';

/** The existing native plugin (Android: CLOCK_TICK, iOS: light impact) — see `refhexFeedback.ts`. */
interface TickHapticsPlugin {
  pulse(options: { double: boolean }): Promise<void>;
}
const nativeHaptics = registerPlugin<TickHapticsPlugin>('RefhexHaptics');

/** Fast spins would buzz continuously; one tick per this many ms is enough. */
const MIN_GAP_MS = 45;
let lastTickAt = 0;

/**
 * One short "detent" tick of the colour dial (GRUNDO #105) when a new colour
 * arrives under the reticle. Respects the Vibrations master switch; silent
 * where no vibration is available (desktop browsers, iOS Safari).
 */
export function dialTick(): void {
  if (!feedbackSettings().vibrationEnabled) return;
  const now = Date.now();
  if (now - lastTickAt < MIN_GAP_MS) return;
  lastTickAt = now;
  try {
    if (Capacitor.isNativePlatform()) {
      if (Capacitor.isPluginAvailable('RefhexHaptics')) void nativeHaptics.pulse({ double: false }).catch(() => undefined);
    } else if (typeof navigator.vibrate === 'function') {
      navigator.vibrate(8);
    }
  } catch {
    // Browser policy (no user gesture yet) — the tick is optional.
  }
}
